import _ from 'underscore';
import { push as pushRoute } from 'connected-react-router';

import {
    all, put, select, takeLatest,
} from 'redux-saga/effects';

import { extractQueryParameters, buildQueryParameters } from 'helpers/RoutesHelpers';
import {
    CLOSE_MODAL,
    setCurrentEventType,
    setCurrentPhone,
    setCurrentMessage,
    setCurrentQuestionType,
} from '../reduxModules/App';
import { getLocationSelector } from '../../commons/selectors/RouterSelector';

export function* callAction() {
    const location = yield select(getLocationSelector);
    const newLocation = location;
    const searchParameters = extractQueryParameters(location.search);
    newLocation.search = buildQueryParameters(_.omit(searchParameters, [
        'support-modal',
        'message',
    ]));
    yield all([
        put(setCurrentEventType('')),
        put(setCurrentPhone('')),
        put(setCurrentMessage('')),
        put(setCurrentQuestionType('')),
        put(pushRoute(newLocation)),
    ]);
}

export function* watch() {
    yield takeLatest(CLOSE_MODAL, callAction);
}
